var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIconBlueCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6523 2.34769C12.134 0.829346 10.1308 0 8 0C5.86922 0 3.85327 0.829346 2.34769 2.34769C0.829346 3.85327 0 5.85646 0 8C0 10.1435 0.829346 12.134 2.34769 13.6523C3.85327 15.1579 5.86922 16 8 16C10.1308 16 12.1467 15.1707 13.6523 13.6523C15.1579 12.1467 16 10.1308 16 8C16 5.86922 15.1579 3.85327 13.6523 2.34769ZM8 14.7368C4.27432 14.7368 1.2504 11.7129 1.2504 7.98724C1.2504 4.26156 4.27432 1.2504 8 1.2504C11.7257 1.2504 14.7496 4.27432 14.7496 8C14.7496 11.7257 11.7129 14.7368 8 14.7368ZM8.6252 7.3748H11.4322V8.6252H8.6252V11.4322H7.3748V8.6252H4.56778V7.3748H7.3748V4.56778H8.6252V7.3748Z",
    fill: "#2191F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIconBlueCircle);
export default __webpack_public_path__ + "static/media/add-icon-blue-circle.42487adbacb2f85490810cba6a002ff7.svg";
export { ForwardRef as ReactComponent };